import React, {useState, Fragment, useCallback, useEffect, useReducer} from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input, Row, Col, Label } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import CommonModal from '../../../Common/Component/CommonModal';
import RequiredField from '../../../../Constant';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { CreateTreatmentMethod, DeleteTreatmentMethod, TreatmentMethodList, TreatmentProcedureList, UpdateTreatmentMethod } from '../../../../apiController';
import { roles_permissions } from '../../../../Layout/Sidebar/Menu';


const initialState = {
  treatmentprocedure:'',
  treatmentmethod:'',
  consultantfee:'',
  methodfee:'',
  id:''
};



const reducer = (state, action) => {
  switch (action.type) {
    
    case 'SET_TREATMENTPROCEDURE':
      return { ...state, treatmentprocedure: action.payload };
    case 'SET_TREATMENTMETHOD':
      return { ...state, treatmentmethod: action.payload };
    case 'SET_METHODFEE':
      return { ...state, methodfee: action.payload };
    case 'SET_CONSULTANTFEE':
      return { ...state, consultantfee: action.payload };
    case 'SET_ID':
      return { ...state, id: action.payload };
    case 'RESET_FORM':
      return initialState;
    default:
      return state;
  }
};
const TreatmentMethod = () =>{

  const [Large, setLarge] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState)
  const LargeModaltoggle = () => {setLarge(!Large); dispatch({type:'RESET_FORM'})};

  const [formdata, setFormdata] = useState({});
  const [treatmentProcedure, setTreatmentProcedure] = useState([]);
  const [treatmentMethod, setTreatmentMethod] = useState([]);

  const permission = roles_permissions.find(module=> module.module_name === "Treatment Method")


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch({ type: `SET_${name.toUpperCase()}`, payload: value });
    
  };

  const handleEdit = (row) => {
    console.log(row)
    // setFormdata({ id: row.id, dname: row.dname , diagnosis: row.name});
    setLarge(!Large);
  dispatch({ type: 'SET_TREATMENTPROCEDURE', payload: row.treatment_procedure_id });
  dispatch({ type: 'SET_TREATMENTMETHOD', payload: row.treatment_method });
  dispatch({ type: 'SET_CONSULTANTFEE', payload: row.doctor_price });
  dispatch({ type: 'SET_METHODFEE', payload: row.method_price });
  dispatch({ type: 'SET_ID', payload: row.id });
  };

  const methodtableColumns = [
    {
        name: '#',
        selector: row => row['ind'],
        sortable: true,
        center: false,
    },
    {
        name: 'Treatment Procedure',
        selector: row => row['treatmentprocedure'],
        sortable: true,
        center: true,
    },
    {
        name: 'Treatment Method',
        selector: row => row['treatmentmethod'],
        sortable: true,
        center: true,
    },
    // {
    //     name: 'Action',
    //     selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
    //     sortable: false,
    //     center: true,
    // },
];

if(permission?.edit_access) {
  methodtableColumns.push(
    {
          name: 'Action',
          selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
          sortable: false,
          center: true,
      },
  )
}

 const treatmentmethod = treatmentMethod.map(((row, ind)=>(
    {
        ind: ind+1,
        id: row.id,
        treatmentprocedure: row.treatment_procedure,
        treatmentmethod: row.treatment_method,
        treatmentprice: row.method_price,
        consultantfee: row.doctor_price,
        action: 
        ({ LargeModaltoggle }) => (
            <span>
                <Btn
                    attrBtn={{
                        style: { width: 60, fontSize: 14, padding: 4 },
                        color: 'success',
                        className: 'btn btn-xs',
                        type: 'button',
                        onClick: () => handleEdit(row)
                    }}
                >
                    Edit
                </Btn>
            </span>
        )
    })
  )
)

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState(treatmentmethod);

    const handleSaveForm = async () => {  

      const formattedData = {
        treatment_procedure_id: state.treatmentprocedure,
        treatment_method : state.treatmentmethod,
        method_price: state.methodfee,
        doctor_price: state.consultantfee,
        id: state.id
    };
    console.log(state)
    console.log(formattedData)
  
    try {
      if (state.id) {
          const response = await UpdateTreatmentMethod(formattedData);
          if (response.status === true) {
              toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
          }
      } else {
          const response = await CreateTreatmentMethod(formattedData);
          if (response.status === true) {
              toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
              
          }
      }
      fetchTreatmentMethod()
      LargeModaltoggle();
  } catch (error) {
      toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
  }
      dispatch({type:'RESET_FORM'})
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = async () => {
      const result = await SweetAlert.fire({
        title: 'Are you sure you want to delete?',
        cancelButtonText: 'No!',
        confirmButtonText: 'Yes!',
        reverseButtons: true,
        showCancelButton: true,
      });
    
      if (result.isConfirmed) {
        try {
          const selectedIds = selectedRows.map(row => row.id); 
          await Promise.all(selectedIds.map(id => DeleteTreatmentMethod(id)));
          setSelectedRows([]);
          toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
          fetchTreatmentMethod()
        } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
        }
      }
    };

    const fetchTreatmentProcedure = async () => {
      const response = await TreatmentProcedureList();
      if (response.status === true) {
        setTreatmentProcedure(response.data);
      }
    };
    const fetchTreatmentMethod = async () => {
      const response = await TreatmentMethodList();
      if (response.status === true) {
        setTreatmentMethod(response.data);
      }
    };

    useEffect(()=>{
      fetchTreatmentMethod()
      fetchTreatmentProcedure()
    },[])
  return (
    <Card>
      <Breadcrumbs mainTitle='Treatment Method' parent='Dashboard' title='treatmentmethod' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            {permission?.create_access &&  <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: LargeModaltoggle }}>+ Add Method</Btn> }
            <CommonModal isOpen={Large} title={"Treatment Method"} toggler={LargeModaltoggle} size="lg" onSave={handleSaveForm} formdata={formdata}>
              <Row>
              <Col sm="12">
                <FormGroup className="mb-3">
                                    <Label htmlFor="exampleFormControlSelect9">{"Treatment Procedure"} <RequiredField/></Label>
                                    <Input type="select" name="treatmentprocedure" className="form-control digits" id="treatmentprocedure" value={state.treatmentprocedure} onChange={handleChange}>
                                    <option  value=''>Select Treatment Procedure</option>
                                 
                                 {treatmentProcedure.map((type)=> <option key={type.id} value={type.id}>{type.treatment_procedure}</option>
                                 )}
                                    </Input>
                                    <span className="text-danger">{errors.treatmentprocedure && "treatmentprocedure is required"}</span>
                                </FormGroup>
            
            </Col>
            <Col sm="12">
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Treatment Method"} <RequiredField/></Label>
              <input className={`form-control ${errors.treatmentmethod && "is-invalid"}`} id="treatmentmethod" type="text" name="treatmentmethod" value={state.treatmentmethod} onChange={handleChange} />
              <span className="text-danger">{errors.treatmentmethod && "Treatment Method is required"}</span>
            </FormGroup>
            </Col>
            <Col className='d-flex gap-5' sm="12">
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Treatment Price"} <RequiredField/></Label>
              <input className={`form-control ${errors.treatmentprice && "is-invalid"}`} id="treatmentprice" type="number" name="methodfee"  value={state.methodfee} onChange={handleChange} />
              <span className="text-danger">{errors.treatmentprice && "Treatment Price is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Consultation Fee"} <RequiredField/></Label>
              <input className={`form-control ${errors.consultationfee && "is-invalid"}`} id="consultationfee" type="number" name="consultantfee" value={state.consultantfee} onChange={handleChange} />
              <span className="text-danger">{errors.consultationfee && "Consultant Fee  is required"}</span>
            </FormGroup>
            </Col>
            </Row>
            </CommonModal>


            
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={treatmentmethod}
                columns={methodtableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default TreatmentMethod